import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { ICmsScreenResponse } from '../../entity/interface/iCmsScreen';
import { JsonType } from '@intigral/types';
import { IGetLanguageUseCase } from '../../core/usecases/cms/GetLanguageUseCase';
import { IGetScreenUseCase } from '../../core/usecases/cms/GetScreenUseCase';
import { ICmsConfigurationResponse } from '../../entity/interface/iCmsConfiguration';
import { IGetDetailsConfigurationUseCase } from '../../core/usecases/cms/GeDetailsConfigurationUseCase';
import { ICmsLanguageResponse } from '../../entity/interface/iCmsLanguage';

export interface ICmsService {
    getConfiguration(): Promise<ICmsConfigurationResponse['data']>;
    getLanguage(language: string): Promise<ICmsLanguageResponse['data']>;
    getScreen(screen: string): Promise<ICmsScreenResponse['data']>;
}

export class CmsService implements ICmsService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get getLanguageUseCase(): IGetLanguageUseCase {
        return container.resolve<IGetLanguageUseCase>(DI.USECASES.IGetLanguageUseCase);
    }

    private get getScreenUseCase(): IGetScreenUseCase {
        return container.resolve<IGetScreenUseCase>(DI.USECASES.IGetScreenUseCase);
    }

    private get getDetailsConfigurationUseCase(): IGetDetailsConfigurationUseCase {
        return container.resolve<IGetDetailsConfigurationUseCase>(DI.USECASES.IGetDetailsConfigurationsUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getConfiguration(): Promise<ICmsConfigurationResponse['data']> {
        return await this.getDetailsConfigurationUseCase.execute();
    }

    async getLanguage(language: string): Promise<ICmsLanguageResponse['data']> {
        const response = await this.getLanguageUseCase.execute(language);
        return response;
    }

    async getScreen(screen: string): Promise<ICmsScreenResponse['data']> {
        const response = await this.getScreenUseCase.execute(screen);

        return response;
    }
}
